module.exports = __webpack_public_path__ + "7fec4ea07a38113fad27cb1abbab7084.png";